@if(error) {
  <div class="alert alert-danger">{{ error }}</div>
}
<h1 data-automation-name="schedulerTaskEditor">
  @switch(editing) {
    @case(true) {
      <span>Edit Scheduler Task {{task.name}}</span>
    }
    @case(false) {
      <span>Create New Scheduler Task</span>
    }
  }
</h1>

<form name="schedulerTaskForm" class="form-horizontal" [formGroup]="schedulerTaskForm">
  <div class="form-group">
    <label for="taskNameId"> Task Name: </label>
    <input id="taskNameId" class="form-control" name="taskName" type="text" formControlName="name" required>
  </div>
  <div class="form-group">
    <label for="callbackUrl"> Callback URL: </label>
    <input id="callbackUrl" class="form-control" name="callbackUrl" type="text" formControlName="url" required>
  </div>
  <div class="form-group">
    <label for="rate"> Rate (seconds): </label>
    <input id="rate" class="form-control" name="rate" type="text" formControlName="rate" required>
  </div>
  <div class="form-group">
    <label for="start"> Start Time: </label>
    <input id="start" class="form-control" name="start" type="text" formControlName="start">
  </div>
  <div class="form-group">
    <label for="type"> Type: </label>
    <select id="type" name="type" formControlName="type" class="form-control">
      <option value="http_get">http_get</option>
      <option value="http_post">http_post</option>
    </select>
  </div>
  <button id="save" class="btn btn-primary" type="button" (click)="save()" [disabled]="schedulerTaskForm.invalid">Save</button>
  <a class="btn" (click)="backPage('/scheduler', router)">Cancel</a>
</form>

<div class="row bg-info" style="margin-top: 10px;">
  <p>Start Time may be entered in the following formats:</p>
  <ul>
    <li>YYYY-MM-DDZ</li>
    <li>YYYY-MM-DDTHH:mmZ</li>
    <li>YYYY-MM-DDTHH:mm:ssZ</li>
  </ul>
</div>
